import {CalendarEntry} from "./calendar-entry";
import {Position} from "./x-enums/position";

export class CalendarDay {
  readonly date: Date;
  readonly strDate;
  outOfMonth: boolean = false;
  calendarEntries: CalendarEntry[] = [];
  position: Position = Position.None;

  constructor(date: Date, outOfMonth: boolean = false) {
    this.date = date

    this.strDate = this.date.toLocaleDateString();
    this.outOfMonth = outOfMonth;
  }
}
